module.exports = __webpack_public_path__ + "static/media/photo67.87b67cfa.jpg";